import { render, staticRenderFns } from "./UserOption.vue?vue&type=template&id=061acd4e&scoped=true&"
import script from "./UserOption.vue?vue&type=script&lang=js&"
export * from "./UserOption.vue?vue&type=script&lang=js&"
import style0 from "./UserOption.vue?vue&type=style&index=0&id=061acd4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061acd4e",
  null
  
)

export default component.exports